import { render, staticRenderFns } from "./drawing.vue?vue&type=template&id=2de2cec4&scoped=true&"
import script from "./drawing.vue?vue&type=script&lang=js&"
export * from "./drawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2cec4",
  null
  
)

export default component.exports